import { formatMoney } from './adminMoney';
import { ADMIN_TRACKED_LABEL } from '../../utils/adminTradeSymbols';

export const EXCLUSION_LABEL = {
  echo: 'Echo (1DTE)',
  test: 'Test / non-client order',
  not_in_master: 'Not on desk list',
  other: 'Not 0DTE / not an option',
};

/** Firestore denies the admin read until the rules in main are deployed. */
export const isRulesDeployPending = (error) => /permission/i.test(String(error || ''));

export const RULES_DEPLOY_COMMAND = 'npx firebase-tools deploy --only firestore:rules --project quantum-flo-auto-algo-d3c2b';

/** Short hint shown under a JTNC figure that could not be computed. */
export const jtncUnavailableHint = (error) =>
  (isRulesDeployPending(error) ? 'Waiting for Firebase deploy' : 'Desk trade list unavailable');

/** Tooltip for the same figure. */
export const jtncUnavailableTitle = (error) =>
  (isRulesDeployPending(error)
    ? `Waiting for Firebase deploy: admin read of the desk trade list and 2025 reimbursements is in main but the Firestore rules are not deployed yet. Run: ${RULES_DEPLOY_COMMAND}`
    : `Desk trade list could not be loaded: ${error}`);

export function jtncLedgerTitle(ledger, since) {
  const base = `${ADMIN_TRACKED_LABEL} option trades on the Tradier account since ${since}, after per-contract commissions, plus JTNC credits/bonuses/refunds, Pro / Pro Plus subscription fees and 2025 technology reimbursements — the same number on the Platform log, the Tradier tab and the Performance chart. Up to the desk reconciliation cutoff only fills on the desk's approved list count; after it, contracts opened on their expiration day (0DTE) count and orders flagged as test are left out. Echo (1DTE) is always left out. Other fees, interest and dividends are left out. Positions still open count at cost.`;
  if (!ledger) return base;
  const parts = [`Trades ${formatMoney(ledger.tradePnl)}`];
  if (ledger.reimbursementPnl) parts.push(`reimbursements ${formatMoney(ledger.reimbursementPnl)}`);
  if (ledger.creditPnl) parts.push(`credits/bonuses ${formatMoney(ledger.creditPnl)}`);
  if (ledger.subscriptionPnl) parts.push(`Pro subscriptions ${formatMoney(ledger.subscriptionPnl)}`);
  const left = Object.entries(ledger.excludedByReason)
    .filter(([, v]) => v)
    .map(([k, v]) => `${EXCLUSION_LABEL[k]} ${formatMoney(v)}`);
  return `${base}\n\n${parts.join(' + ')}${left.length ? `. Left out: ${left.join(', ')}.` : '.'}`;
}
